module.exports = __webpack_public_path__ + "static/media/team_icon.98141f52.svg";